const firebaseConfig = {

    apiKey: "AIzaSyCcJYLDPicWEURGruQ0Y_TaXdKppQo9Jt8",
    authDomain: "carhub-72958.firebaseapp.com",
    projectId: "carhub-72958",
    storageBucket: "carhub-72958.appspot.com",
    messagingSenderId: "848896389775",
    appId: "1:848896389775:web:9993fd43161d82bdca36fa"
  };

export default firebaseConfig;
  